module.exports = __webpack_public_path__ + "static_pc/img/wx4.11a379ce.png";